<template>
    <div  :style="'height:' + height" style="width:100%">
        <slot></slot>
    </div>
  </template>
  <script>
  export default {
    name:"layout_bigscreen",
    props:{
      nav_top:{
        type:[Number,String],
        default: 0
      }
    },
    data() {
      return {
        height: document.documentElement.clientHeight - this.nav_top + "px;",
        loading: true
      };
    },
    mounted: function () {
      const that = this;
      window.onresize = function temp() {
        that.height = document.documentElement.clientHeight - this.nav_top + "px;";
      };
    }
  };
  </script>
  